import { all1cProjectsData, allProjectsData } from 'constants/Projects';

export const getSlidesData = (name, onChangeProject, is1C = false) =>
  (is1C ? [...all1cProjectsData, ...allProjectsData] : [...allProjectsData, ...all1cProjectsData])
    .filter(project => project.name !== name)
    .map(project => ({
      logoImage: project.icon_full,
      description: project.description,
      logoImageProps: project.icon_fullSx,
      name: project.name,
      tag: project.tag,
      onChangeProject,
    }));
